<template>
  <div class="content-container">
    <div class="das-layout flex-1 gap-20">
      <div class="l-w-30 flex">
        <div class="flex-1">
          <GridEnterprise
            ref="agGrid"
            :columns="columnDefs"
            :rows="transactions"
            dom-layout="scroll"
            :auto-size-cell="true"
            class="agGrid"
            @selectionChanged="onTransactionRowClicked"
          />
        </div>
      </div>
      <div class="l-w-70 flex">
        <div v-loading="subTransactionLoading" class="flex-1">
          <GridVx
            ref="subTransactionGrid"
            :columns="columns"
            :auto-select-first-row="false"
            :row-multi-select-with-click="true"
            dom-layout="scroll"
            :rows="subTransactions"
            class="agGrid"
            @selectionChanged="subTransactionSelectionChanged"
          />
        </div>
      </div>
    </div>
    <div class="flex justify-space-between">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          :disabled="transactionSelectedRows.length === 0"
          @click="deleteTransaction"
        >
          {{ $t('button.deleteTransactionCode') }}
        </button>
        <button
          class="btn primary small"
          :disabled="transactionSelectedRows.length === 0"
          @click="editTransactionCode"
        >
          {{ $t('button.modifyTransactionCode') }}
        </button>
        <button class="btn primary small" @click="dialogFormVisible = true">
          {{ $t('button.addTransactionCode') }}
        </button>
      </div>
      <div class="button-containers mb-0">
        <button
          class="btn primary small outline"
          :disabled="subTransactionSelectionSelectedRows.length === 0"
          @click="deleteSubTransaction"
        >
          {{ $t('button.deleteSubTransactionCode') }}
        </button>
        <button
          class="btn primary small outline"
          :disabled="subTransactionSelectionSelectedRows.length !== 1"
          @click="editSubTransaction"
        >
          {{ $t('button.modifySubTransactionCode') }}
        </button>
        <button
          class="btn primary small"
          :disabled="transactionSelectedRows.length === 0"
          @click="openSubTransactionDialog"
        >
          {{ $t('button.addSubTransactionCode') }}
        </button>
        <button
          class="btn primary small"
          :disabled="transactionSelectedRows.length === 0"
        >
          {{ $t('button.downloadExcel') }}
        </button>
      </div>
    </div>
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.transactionDefinitionUpdate')
          : $t('dialog.transactionDefinitionAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Loại giao dịch">
                  <div class="das-form-input">
                    <div class="label required">Loại giao dịch:</div>
                    <el-select
                      v-model="transactionItem.transaction_group"
                      placeholder=""
                    >
                      <el-option
                        v-for="item in transactionGroupTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <!-- <div class="child-w-80">
                      <select v-model="transactionItem.transaction_group">
                        <option
                          v-for="item in transactionGroupTypeOptions"
                          :key="item.value"
                          :value="item.value"
                        >
                          {{ item.label }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="Mã giao dịch"
                >
                  <div class="das-form-input">
                    <div class="label required">Mã giao dịch:</div>
                    <div class="child-w-80">
                      <input v-model="transactionItem.code" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 255" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">Mô tả:</div>
                    <div class="child-w-80">
                      <textarea
                        v-model="transactionItem.description"
                        rows="4"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateTransaction"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addTransaction">
            {{ $t('button.create') }}
          </button>
        </div>
        <!-- <el-button @click="subDialogFormVisible = false">Huỷ</el-button>
        <el-button
          v-if="isEdit"
          type="primary"
          @click="updateTransaction"
        >Cập nhật</el-button>
        <el-button
          v-else
          type="primary"
          @click="addTransaction"
        >Tạo mới</el-button> -->
      </span>
    </el-dialog>
    <el-dialog
      :title="
        isSubEdit
          ? $t('dialog.subTransactionDefinitionUpdate')
          : $t('dialog.subTransactionDefinitionAdd')
      "
      :close-on-click-modal="false"
      :visible.sync="subDialogFormVisible"
      width="800px"
    >
      <!-- <div style="display: flex; gap: 20px">
        <span style="margin-right: 30px"
          >Mã giao dịch: Nhà hàng Boiler Mariot</span
        >
        <span>{{
          subTransactionItem.transaction_type == 1
            ? 'Nhóm giao dịch: Doanh thu'
            : 'Nhóm giao dịch: Thanh toán'
        }}</span>
      </div> -->
      <validation-observer ref="formBValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="Mã giao dịch phụ"
                >
                  <div class="das-form-input">
                    <div class="label required">Mã giao dịch phụ:</div>
                    <div class="child-w-80">
                      <input v-model="subTransactionItem.code" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">Mô tả:</div>
                    <div class="child-w-80">
                      <input
                        v-model="subTransactionItem.description"
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Loại giao dịch">
                  <div class="das-form-input">
                    <div class="label required">Loại giao dịch:</div>
                    <el-select
                      v-model="subTransactionItem.transaction_type"
                      placeholder=""
                      @change="transactionTypeChange"
                    >
                      <el-option
                        v-for="item in transactionOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <!-- <div class="child-w-80">
                      <select v-model="subTransactionItem.transaction_type">
                        <option
                          v-for="item in transactionOptions"
                          :key="item.value"
                          :value="item.value"
                        >
                          {{ item.label }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
              <!-- <div class="das-form-col col-6">
                <validation-provider rules="required" name="Dịch vụ khách sạn">
                  <div class="das-form-input">
                    <div class="label required">Dịch vụ khách sạn:</div>
                    <el-select
                      v-model="subTransactionItem.hotel_service"
                      placeholder=""
                    >
                      <el-option label="Chọn" :value="null"></el-option>
                      <el-option
                        v-for="item in hotelServiceOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div> -->
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Loại giao dịch phụ">
                  <div class="das-form-input">
                    <div class="label required">Loại giao dịch phụ:</div>
                    <el-select
                      v-model="subTransactionItem.sub_transaction_type"
                      placeholder=""
                    >
                      <!-- <el-option label="Chọn" :value="null"></el-option> -->
                      <el-option
                        v-for="item in subTransactionTypeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <div class="child-w-80">
                      <select v-model="subTransactionItem.sub_transaction_type">
                        <option
                          v-for="item in subTransactionTypeOptions"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Phí dịch vụ">
                  <div class="das-form-input">
                    <div class="label required">Phí dịch vụ:</div>
                    <el-select
                      v-model="subTransactionItem.service_fee_id"
                      placeholder=""
                    >
                      <el-option
                        v-for="item in servFreeOptions"
                        :key="item.id"
                        :label="item.code"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <div class="child-w-80">
                      <select v-model="subTransactionItem.service_fee_id">
                        <option
                          v-for="item in servFreeOptions"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.desc }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Thuế">
                  <div class="das-form-input">
                    <div class="label required">Thuế:</div>
                    <el-select v-model="subTransactionItem.tax" placeholder="">
                      <!-- <el-option label="Chọn" :value="null"></el-option> -->
                      <el-option
                        v-for="item in taxOptions"
                        :key="item.id"
                        :label="item.code"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <div class="child-w-80">
                      <select v-model="subTransactionItem.tax">
                        <option
                          v-for="item in taxOptions"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.desc }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </validation-provider>
              </div>
            </div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Thuế đặc biệt">
                  <div class="das-form-input">
                    <div class="label required">Thuế đặc biệt:</div>
                    <el-select
                      v-model="subTransactionItem.special_tax"
                      placeholder=""
                    >
                      <el-option
                        v-for="item in specialTaxOptions"
                        :key="item.id"
                        :label="item.code"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div> -->
            <div class="das-form-row align-end">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Thông tin khác:</div>
                  <div class="flex gap-10">
                    <div class="checkbox-container">
                      <div class="checkbox-wrap">
                        <input
                          id="cpSpdTp3"
                          v-model="subTransactionItem.allow_adding_manual"
                          type="checkbox"
                        />
                        <label for="cpSpdTp3">Cho phép thêm thủ công</label>
                      </div>
                      <div class="checkbox-wrap">
                        <input
                          id="cpSpdTp4"
                          v-model="subTransactionItem.cash_app"
                          type="checkbox"
                        />
                        <label for="cpSpdTp4">Ứng tiền mặt</label>
                      </div>
                      <div class="checkbox-wrap">
                        <input
                          id="cpSpdTp5"
                          v-model="subTransactionItem.hotel_transaction"
                          type="checkbox"
                        />
                        <label for="cpSpdTp5">Giao dịch khách sạn</label>
                      </div>
                      <div class="checkbox-wrap">
                        <input
                          id="cpSpdTp6"
                          v-model="subTransactionItem.business_transaction"
                          type="checkbox"
                        />
                        <label for="cpSpdTp6">Giao dịch khu kinh doanh</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="subDialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isSubEdit"
            class="btn primary small"
            @click="updateSubTransaction"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addSubTransaction">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getSubTransactionApi,
  getTransactionApi,
  addTransactionApi,
  updateTransactionApi,
  deleteTransactionApi
} from '@/api/configuration/accounting/transaction.js'
import {
  addSubTransactionApi,
  updateSubTransactionApi,
  deleteSubTransactionApi
} from '@/api/configuration/accounting/subTransaction.js'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import { transactionDat } from './subTransaction/components/data.js'
export default {
  components: {
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      isSubEdit: false,
      transactionSelectedRows: [],
      subTransactionSelectionSelectedRows: [],
      gridOptions: null,
      gridApi: null,
      columnDefs: null,
      transactionOptions: [],
      // transactionOptions: [
      //   {
      //     value: 1,
      //     label: 'Thuê phòng'
      //   },
      //   {
      //     value: 2,
      //     label: 'Đồ ăn và đồ uống'
      //   },
      //   {
      //     value: 3,
      //     label: 'Spa'
      //   },
      //   {
      //     value: 4,
      //     label: 'Karaoke'
      //   },
      //   {
      //     value: 5,
      //     label: 'Shop'
      //   },
      //   {
      //     value: 6,
      //     label: 'Điện thoại'
      //   },
      //   {
      //     value: 7,
      //     label: 'Minibar'
      //   },
      //   {
      //     value: 8,
      //     label: 'Thuế'
      //   },
      //   {
      //     value: 9,
      //     label: 'Không là doanh thu'
      //   },
      //   {
      //     value: 10,
      //     label: 'Khác'
      //   },
      //   {
      //     value: 11,
      //     label: 'Chuyển'
      //   }
      // ],
      subTransactionTypeOptions: [],
      hotelServiceOptions: [
        {
          value: 0,
          label: 'DISCOUNT ROOM CHARGE'
        },
        {
          value: 1,
          label: 'DISCOUNT F&B'
        }
      ],
      feeIdOptions: [
        {
          value: 0,
          label: 'S0 - Non Svc'
        },
        {
          value: 1,
          label: 'Service Chare 5%'
        }
      ],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã giao dịch phụ',
          field: 'code',
          tooltipField: 'code',
          maxWidth: 150
          // children: [{}],
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description'
        },
        {
          headerName: 'Loại giao dịch',
          field: 'transaction_type_name',
          tooltipField: 'transaction_type_name',
          maxWidth: 150
        },
        {
          headerName: 'Loại giao dịch phụ',
          field: 'sub_transaction_type_name',
          tooltipField: 'sub_transaction_type_name',
          maxWidth: 150
        },
        {
          headerName: 'Phí dịch vụ',
          field: 'service_fee_code',
          tooltipField: 'service_fee_code',
          maxWidth: 150
        },
        {
          headerName: 'Thuế',
          field: 'tax_code',
          maxWidth: 100
        },
        {
          headerName: 'Dịch vụ khách sạn',
          field: 'service_fee_code',
          tooltipField: 'service_fee_code'
        },
        {
          headerName: 'Áp dụng cho',
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-group-cell-divide-right',
            'header-cell-center'
          ],
          cellClass: 'grid-cell-centered',
          children: [
            {
              headerName: 'Khách sạn',
              field: 'hotel_transaction',
              headerClass: 'header-cell-center',
              tooltipField: 'hotel_transaction',
              cellRenderer: 'CellRenderCheckboxReadonly',
              cellClass: 'grid-cell-align-center',
              maxWidth: 130
            },
            {
              headerName: 'Khu kinh doanh',
              field: 'business_transaction',
              headerClass: 'header-cell-center',
              cellClass: 'grid-cell-align-center',
              tooltipField: 'business_transaction',
              cellRenderer: 'CellRenderCheckboxReadonly',
              maxWidth: 130
            }
          ]
        },
        {
          headerName: 'Cho phép thêm thủ công',
          field: 'business_transaction',
          headerClass: 'header-cell-center',
          tooltipField: 'business_transaction',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        },
        {
          headerName: 'Ứng tiền mặt',
          field: 'cash_app',
          headerClass: 'header-cell-center',
          tooltipField: 'cash_app',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      transactionItem: {
        transaction_group: 1,
        code: '',
        description: '',
        id: ''
      },
      subTransactionItem: {
        code: '',
        transaction_id: null,
        transaction_type: null,
        sub_transaction_type: null,
        service_fee_id: null,
        special_tax: null,
        tax: null,
        description: '',
        hotel_service: 1,
        allow_adding_manual: false,
        cash_app: false,
        hotel_transaction: false,
        business_transaction: false,
        description: ''
      },
      transactionGroupTypeOptions: [
        {
          label: 'Doanh thu',
          value: 1
        },
        {
          label: 'Thanh toán',
          value: 2
        }
      ],
      transactions: [],
      subTransactions: [],
      servFreeOptions: [],
      taxOptions: [],
      specialTaxOptions: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      subDialogFormVisible: false,
      subTransactionLoading: false
    }
  },
  watch: {
    // isEdit() {
    //   alert(this.isEdit)
    // },
    dialogFormVisible() {
      // this.isEdit = false
      this.dialogFormVisible ? null : this.resetInfoTransaction()
    },
    subDialogFormVisible() {
      this.subDialogFormVisible ? null : this.resetInfoSubTransaction()
    }
  },
  beforeMount() {
    this.gridOptions = {}
    this.columnDefs = [
      {
        field: 'transaction_group',
        valueGetter: params => {
          if (params.data.transaction_group == 1) {
            return 'Doanh thu'
          } else {
            return 'Thanh toán'
          }
        },
        rowGroup: true,
        hide: true
      },
      {
        headerName: 'Mã',
        // headerClass: 'header-cell-center',
        // cellClass: 'grid-cell-centered',
        field: 'code',
        width: 100
      },
      {
        headerName: 'Mô tả',
        field: 'description',
        tooltipField: 'description'
        // headerClass: 'header-cell-center',
        // cellClass: 'grid-cell-centered'
      }
    ]
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.getTransaction()
    this.getServFreeOptions()
    this.getTaxOptions()
    this.getSpecialTaxOptions()
  },
  methods: {
    transactionTypeChange(dat) {
      this.getSubTransactionTypeOptions(dat)
    },
    subTransactionSelectionChanged(rows) {
      this.subTransactionSelectionSelectedRows = rows
    },
    resetInfoTransaction() {
      this.isEdit = false
      this.transactionItem = {
        transaction_group: 1,
        code: '',
        description: '',
        id: ''
      }
    },
    resetInfoSubTransaction() {
      this.isSubEdit = false
      this.subTransactionItem = {
        code: '',
        transaction_id: null,
        transaction_type: null,
        sub_transaction_type: null,
        service_fee_id: null,
        special_tax: null,
        tax: null,
        description: '',
        hotel_service: 1,
        allow_adding_manual: false,
        cash_app: false,
        hotel_transaction: false,
        business_transaction: false,
        description: ''
      }
    },
    getTaxOptions() {
      this.$axios.get('/config-service/v1/tax/list').then(res => {
        this.taxOptions = res.data
      })
    },
    getSpecialTaxOptions() {
      this.$axios
        .get('/config-service/v1/statistic/code/code-base?pCode=SPECIALTAX')
        .then(res => {
          this.specialTaxOptions = res.data
        })
    },
    getServFreeOptions() {
      this.$axios.get('/config-service/v1/service-charge/list').then(res => {
        this.servFreeOptions = res.data
      })
    },
    getSubTransactionTypeOptions(id) {
      const params = {
        transactionTypeId: id
      }
      this.$axios
        .get('/config-service/v1/transaction/sub-transaction-type', {
          params: params
        })
        .then(res => {
          this.subTransactionTypeOptions = res.data || []
        })
    },
    async onTransactionRowClicked(row) {
      this.subTransactionLoading = true
      this.transactionSelectedRows = row
      this.subTransactionItem.transaction_id = row[0].id
      await this.getSubTransaction(row[0].id)
      this.subTransactionLoading = false
    },
    async getTransaction() {
      this.transactionSelectedRows = []
      bus.$emit('startLoader', { msg: '' })
      let data = await getTransactionApi({
        transactionGroup: 0
      })
      bus.$emit('endLoader')
      const transactionRows = []
      data.data.map(item => {
        if (!item.transaction_group_name) {
          transactionRows.push(item)
        }
      })
      this.transactions = transactionRows
      this.subTransactions = []
    },
    async getSubTransaction(id) {
      let data = await getSubTransactionApi({
        transactionId: id
      })
      this.subTransactions = data.data
      this.subTransactionSelectionSelectedRows = []
    },
    // Sub Table Controller
    onSubRowClick(index) {
      document
        .getElementById(`sub-transaction-${index}`)
        .classList.add('row-focus')
    },
    // CRUD Sub-Transaction
    async addSubTransaction() {
      // bus.$emit('startLoader', { msg: '' })
      if ((await this.$vxForm.isValid(this.$refs.formBValidator)) === false) {
        return
      }
      let data = await addSubTransactionApi(this.subTransactionItem)
        .then(async res => {
          const message = res.message
          await this.getSubTransaction(this.subTransactionItem.transaction_id)
          this.subDialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    openSubTransactionDialog() {
      this.subTransactionItem.transaction_id =
        this.transactionSelectedRows[0].id || null
      this.subDialogFormVisible = true
      Object.assign(this.transactionOptions, transactionDat)
    },
    async editSubTransaction() {
      this.isSubEdit = true
      Object.assign(this.transactionOptions, transactionDat)
      const row = this.subTransactionSelectionSelectedRows[0]
      //
      Object.assign(this.subTransactionItem, row)
      await this.getSubTransactionTypeOptions(row.transaction_type)
      this.subDialogFormVisible = true
    },
    async updateSubTransaction() {
      let data = await updateSubTransactionApi(this.subTransactionItem)
        .then(async res => {
          const message = res.message
          await this.getSubTransaction(this.subTransactionItem.transaction_id)
          this.subDialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
      // if (this.subTransactionItem.transaction_group_name == '') {
      //   this.$alert('Bạn phải điền đủ các trường thông tin', 'Error', {
      //     confirmButtonText: 'OK'
      //   })
      // } else {
      //   let data = await updateSubTransactionApi(this.subTransactionItem)
      //   this.subDialogFormVisible = false
      //   this.$message({
      //     type: 'success',
      //     message: 'Cập nhật định nghĩa giao dịch phụ thành công'
      //   })
      //   this.getSubTransaction(this.subTransactionItem.transaction_id)
      // }
    },
    deleteSubTransaction() {
      const ids = this.subTransactionSelectionSelectedRows.map(item => item.id)

      this.$vxConfirm(this.$t('alert.deleteSubTransactionConfirm'), () => {
        deleteSubTransactionApi({
          id_list: ids
        })
          .then(async res => {
            const message = res.message
            const gridApi = this.$refs.agGrid.gridApi
            const rowsSelected = gridApi.getSelectedRows()[0]
            await this.getSubTransaction(rowsSelected.id)
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    // CRUD Transaction
    async addTransaction() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      // if(this.transactionItem.code == '' || this.transactionItem.description == ''){
      //   this.$alert('Bạn phải điền đủ các trường thông tin', 'Error', {
      //     confirmButtonText: 'OK',
      //   });
      // } else {

      // }
      let data = await addTransactionApi(this.transactionItem)
        .then(async res => {
          const message = res.message
          await this.getTransaction()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
      // this.dialogFormVisible = false
      // await this.getTransaction()
      // this.$message({
      //   type: 'success',
      //   message: 'Thêm định nghĩa giao dịch thành công'
      // })
    },
    editTransactionCode() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          message: 'Vui lòng chọn giao dịch',
          type: 'error'
        })
        return false
      }
      this.isEdit = true
      Object.assign(this.transactionItem, row)
      this.dialogFormVisible = true
    },
    async updateTransaction() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateTransactionApi(this.transactionItem)
        .then(async res => {
          const message = res.message
          await this.getTransaction()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
      // this.dialogFormVisible = false
      // this.$message({
      //   type: 'success',
      //   message: 'Cập nhật định nghĩa giao dịch thành công'
      // })
      // this.getTransaction()
    },
    async deleteTransaction() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectTransactionRow')
        })
        return false
      }
      const id_list = []
      id_list.push(row.id)
      if (id_list.length == 0) {
        this.$message({
          message: 'Vui lòng chọn loại giao dịch',
          type: 'error'
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteTransactionConfirm'), () => {
          deleteTransactionApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.getTransaction()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
